import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const defaultScope = {
  scopeSerials: null,
  scopeLabel: 'All Site',
  isSiteWide: true,
};

const OptimizeScopeContext = createContext({
  ...defaultScope,
  setOptimizeScope: () => {},
});

export function OptimizeScopeProvider({ children }) {
  const [scope, setScopeState] = useState(defaultScope);
  const setOptimizeScope = useCallback((next) => {
    if (!next) return;
    setScopeState((prev) => ({
      scopeSerials: next.scopeSerials !== undefined ? next.scopeSerials : prev.scopeSerials,
      scopeLabel: next.scopeLabel !== undefined ? next.scopeLabel : prev.scopeLabel,
      isSiteWide: next.isSiteWide !== undefined ? next.isSiteWide : prev.isSiteWide,
    }));
  }, []);
  const value = useMemo(() => ({ ...scope, setOptimizeScope }), [scope, setOptimizeScope]);
  return (
    <OptimizeScopeContext.Provider value={value}>
      {children}
    </OptimizeScopeContext.Provider>
  );
}

export function useOptimizeScope() {
  const ctx = useContext(OptimizeScopeContext);
  if (!ctx) {
    return { ...defaultScope, setOptimizeScope: () => {} };
  }
  return ctx;
}

export default OptimizeScopeContext;
